module.exports = __webpack_public_path__ + "assets/img/img_2_9_5.b028cdd7.png";